import React from "react";
import { connect } from "react-redux";

import { OTransportCompanies } from "shared/gol-api/types/flightSearch";

interface Props {
  airlineCode: string;
  oTransportCompanies: OTransportCompanies;
}

const AirlineTitle: React.FC<Props> = ({
  airlineCode,
  oTransportCompanies,
}: Props) => {
  const title = oTransportCompanies[airlineCode]
    ? oTransportCompanies[airlineCode].Name.$t
    : null;
  return <span>{title}</span>;
};

const mapStateToProps = (state) => ({
  oTransportCompanies: state.search.oTransportCompanies,
});

export default connect(mapStateToProps)(AirlineTitle);
